import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class CustomValidationService {
  /* Regex patterns for validation */
  lengthRegex = new RegExp('^.{9,}$');
  upperCaseRegex = new RegExp('[A-Z]+');
  lowerCaseRegex = new RegExp('[a-z]+');
  numberRegex = new RegExp('[0-9]+');
  specialCharRegex = new RegExp(/[!@#%&~\$\*\+\?\^]/);
  websiteRegex = new RegExp(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
  );

  /* Regex validation booleans required for HTML only */
  lengthInvalid: boolean;
  upperCaseInvalid: boolean;
  lowerCaseInvalid: boolean;
  numberInvalid: boolean;
  specialCharInvalid: boolean;
  websiteInvalid: boolean;

  /* Regex generic function for custom validation */
  runRegexValidation(validationName, validationScript) {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        this[validationName] = null;
        return null as any;
      }
      const valid = validationScript.test(control.value);
      if (valid) {
        this[validationName] = false;
        return null as any;
      } else {
        this[validationName] = true;
        return { [validationName]: true };
      }
    };
  }

  /* This fn check if two passwords are the same */
  passwordMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName].value;
      const matchingControl = formGroup.controls[matchingControlName].value;
      if (control != matchingControl) {
        formGroup.controls[matchingControlName].setErrors({ noMatch: true });
      } else {
        formGroup.controls[matchingControlName].setErrors(null);
      }
      return control === matchingControl ? null : { notMatch: true };
    };
  }

  /* Password length validation */
  passwordLength(): ValidatorFn {
    return this.runRegexValidation('lengthInvalid', this.lengthRegex);
  }

  /* Upper case validation */
  passwordUpperCase(): ValidatorFn {
    return this.runRegexValidation('upperCaseInvalid', this.upperCaseRegex);
  }

  /* Lower case validation */
  passwordLowerCase(): ValidatorFn {
    return this.runRegexValidation('lowerCaseInvalid', this.lowerCaseRegex);
  }

  /* Number validation */
  passwordNumber(): ValidatorFn {
    return this.runRegexValidation('numberInvalid', this.numberRegex);
  }

  /* Special character validation */
  passwordSpecialCharacter(): ValidatorFn {
    return this.runRegexValidation('specialCharInvalid', this.specialCharRegex);
  }

  /* Special character validation */
  websiteUrl(): ValidatorFn {
    return this.runRegexValidation('websiteInvalid', this.websiteRegex);
  }
}
